export const intcmpMap = {
    driverStatistics: 'skysport_sportsdata_driver-statistics_detail-link',
    seasonRankingGallery: {
        tabDrivers: 'skysport_motori-dynamic-widget_piloti_tab',
        tabTeams: 'skysport_motori-dynamic-widget_costruttori_tab',
        cardFull: 'skysport_motori-dynamic-widget_card-pilota_detail-link',
        cardLogo: 'skysport_motori-dynamic-widget_card-pilota_detail-link'
    },
    dataCardCalendar: {
        detailLink: 'skysport_homepage_card-calendar-motorsport-formula1_detail-link',
        viewAllCta: 'skysport_homepage_card-calendar-motorsport-formula1_view-all-cta'
    },
    dataCardGpResults: {
        detailLink: 'skysport_homepage_card-results-motorsport-formula1_detail-link',
        viewAllCta: 'skysport_homepage_card-results-motorsport-formula1_view-all-cta'
    },
    dataCardDriverRanking: {
        detailLink: 'skysport_homepage_card-driver-ranking-motorsport-formula1_detail-link',
        viewAllCta: 'skysport_homepage_card-driver-ranking-motorsport-formula1_view-all-cta'
    },
    dataCardTeamRanking: {
        detailLink: 'skysport_homepage_card-ranking-motorsport-formula1-team_detail-link',
        viewAllCta: 'skysport_homepage_card-ranking-motorsport-formula1-team_view-all-cta'
    },
    teamsDrivers: {
        dataAttribute: 'intcmp',
        driverLink: 'skysport_sportsdata_team-piloti_pilota',
        teamLink: 'skysport_sportsdata_team-piloti_team',
    },
    podiumList: {
        dataAttribute: 'intcmp',
        driverLink: 'skysport_sportsdata_pilota_risultati',
        teamLink: 'skysport_sportsdata_team_risultati',
    },
    intcmpLgpTemplate: 'skysport_sportsdata_<%intcmp%>_tab',
    driverLink: 'skysport_sportsdata_risultati_detail-link',
    teamsRanking: {
        dataAttribute: 'intcmp',
        teamLink: 'skysport_sportsdata_team_classifica'
    },
    driversRanking: {
        dataAttribute: 'intcmp',
        driverLink: 'skysport_sportsdata_pilota_classifica',
        teamLink: 'skysport_sportsdata_team_classifica',
    }
};